import { Injectable } from "@angular/core";
import { AccountUserGroupsHandlerService } from "../handlers/account-user-groups-handler.service";
import { AccountUserGroupsUserHandlerService } from "../handlers/account-user-groups-user-handler.service";

@Injectable({
  providedIn: "root",
})
export class AccountUserGroupService {
  constructor(
    private AccountUserGroupHandler: AccountUserGroupsHandlerService,
    private AccountUserGroupsUserHandlerService: AccountUserGroupsUserHandlerService,
  ) {}

  getAccountUserGroup(accountID: number, groupID: number) {
    return this.AccountUserGroupHandler.getAccountUserGroup(accountID, groupID);
  }

  getAccountUserGroups(
    accountID: number,
    queryParams?: {
      page?: number;
      perPage?: number;
    },
  ) {
    return this.AccountUserGroupHandler.getAccountUserGroups(
      accountID,
      queryParams,
    );
  }

  deleteAccountUserGroup(masterAccountID: number, group: any) {
    return this.AccountUserGroupHandler.deleteAccountUserGroup(
      masterAccountID,
      group,
    );
  }

  createAccountUserGroup(masterAccountID: number, group: any) {
    return this.AccountUserGroupHandler.postAccountUserGroup(
      masterAccountID,
      group,
    );
  }

  updateAccountUserGroup(masterAccountID: number, group: any) {
    return this.AccountUserGroupHandler.putAccountUserGroup(
      masterAccountID,
      group,
    );
  }

  deleteAccountUserGroupUser(
    masterAccountID: number,
    accountUserGroupUser: any,
  ) {
    return this.AccountUserGroupsUserHandlerService.deleteAccountUserGroupUser(
      masterAccountID,
      accountUserGroupUser,
    );
  }

  createAccountUserGroupUser(
    masterAccountID: number,
    accountUserGroupUser: any,
  ) {
    return this.AccountUserGroupsUserHandlerService.postAccountUserGroupUser(
      masterAccountID,
      accountUserGroupUser,
    );
  }
}
